import type { Alpine } from 'alpinejs'
import collapse from '@alpinejs/collapse'

import { glossaryFilter } from '@components/glossary/glossary-filter'

export default (Alpine: Alpine) => {
  Alpine.plugin(collapse)
  Alpine.data('glossaryFilter', glossaryFilter)
}
